import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
const FormData = ({
    show,
    handleClose,
    formAttribute,
    handleChange,
    handleChangeFormEditor,
    handleSubmit,
    isLoading,
    validate
}) => {
    const { title, data } = formAttribute;
    const vcimage = data.vcimage === '' ? '' : `data:image/jpeg/jpg/png;base64,${data.vcimage}`
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="xl">
            <Modal.Header className="bg-card-gradient light border-bottom-0">
                <Modal.Title className="text-white">{title}</Modal.Title>
                <FalconCloseButton onClick={handleClose} variant="white"/>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validate} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formJudul">
                        <Form.Label>Judul</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={data?.vcnama} 
                            onChange={(event) => handleChange(event)} 
                            name="vcnama" 
                            placeholder="Judul"
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Judul tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupDeskripsi">
                        <Form.Label>Deskripsi</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcdeskripsi}
                            onChange={(event) => handleChange(event)}
                            name="vcdeskripsi"
                            placeholder="Deskripsi"
                        />
                        <Form.Control.Feedback type="invalid">
                            Deskripsi tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formJudul">
                        <Form.Label>Judul</Form.Label>
                        <Form.Select 
                            type="text" 
                            value={data?.inttype} 
                            onChange={(event) => handleChange(event)} 
                            name="inttype"
                        >
                            <option value="">-- Pilih Tipe --</option>
                            <option value={1}>Home</option>
                            <option value={2}>Tiket</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formImage">
                        <Form.Label>Gambar (Usahakan ukuran gambar 1280 x 695)</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={(event) => handleChange(event)}
                            name="vcimage"
                            placeholder="Gambar"
                        />
                        <img src={vcimage} alt="default" width="20%" className={vcimage === '' ? 'd-none' : ''}/>
                    </Form.Group>
                    
                    <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                    </Button>
                    <Button disabled={isLoading} type="submit" className="float-end">
                        {isLoading ? (<>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Loading...
                        </>
                        ) : (<>
                            <FontAwesomeIcon icon={faSave} className="me-2" />
                            Simpan
                        </>) }
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

FormData.propTypes = {}

export default FormData;